import { AfterViewInit, Component, ElementRef, ViewChild } from '@angular/core';
import { DeviceService } from 'src/app/services/device.service';
import { TextAnimation } from 'src/app/services/animation.service';
import { LocaleService } from 'src/app/services/locale.service';

@Component({
  selector: 'security-page',
  templateUrl: './security-page.component.html',
  styleUrls: ['./security-page.component.scss'],
  providers: [DeviceService]
})

export class SecurityPageComponent implements AfterViewInit {
  static TITLES = ['Trusted', 'Committed', 'Reliant'];

  @ViewChild('animationText') animationText: ElementRef<HTMLElement>;

  constructor(private localeService: LocaleService) {
    if (localeService.isArabic()) {
      SecurityPageComponent.TITLES = ['موثوقة', 'ملتزمة', 'آمنة'];
    }
  }

  ngAfterViewInit() {
    const animationInstance = new TextAnimation(this.animationText.nativeElement, SecurityPageComponent.TITLES);
    animationInstance.run();
  }
}
